import { useContext } from "react";
import {
  BoardIdContext,
  BoardShipmentIds,
} from "./state-machine/reviewBoardFlowLoader";
import { DownloadableFileResponse } from "../../uploadToS3";
import useSWRFetcher from "../fetcher";
import useSWR from "swr";
import settings from "../../../../constants/settings";

export interface CustomerImageFilesResponse {
  assembly_drawings: DownloadableFileResponse[];
  fab_drawings: DownloadableFileResponse[];
  reference_files: DownloadableFileResponse[];
}

function useGetCustomerImageFiles() {
  const fetcher = useSWRFetcher<CustomerImageFilesResponse>();
  const { boardId } = useContext(BoardIdContext) as BoardShipmentIds;
  const { data, mutate } = useSWR(
    `${settings.api_url}/boards/${boardId}/customer-image-files`,
    fetcher,
  );

  return {
    customerFilesResponse: data || null,
    refreshCustomerFilesResponse: () => mutate(),
  };
}

export default useGetCustomerImageFiles;
